var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46189 1.98735C6.46189 1.7593 6.27722 1.57422 6.04876 1.57422C3.77077 1.57422 1.91748 3.42751 1.91748 5.7055C1.91748 5.93355 2.10215 6.11863 2.33061 6.11863C2.55907 6.11863 2.74374 5.93355 2.74374 5.7055C2.74374 3.88319 4.22645 2.40048 6.04876 2.40048C6.27722 2.40048 6.46189 2.21539 6.46189 1.98735Z",
    fill: "url(#paint0_linear_4163_830)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3242 18H6.04883H6.77346C7.45595 18 8.01243 17.4443 8.01284 16.7606V16.3066C8.43919 16.1104 8.73788 15.6819 8.73788 15.1825V13.6456C8.81059 13.4878 8.85397 13.3143 8.85397 13.1292C8.85397 12.7095 8.94734 12.303 9.13118 11.92C9.31337 11.5403 9.57984 11.1962 9.90125 10.9248C11.4488 9.61721 12.2598 7.62428 12.0702 5.59169C11.781 2.54487 9.25553 0.142942 6.1769 0.00413128L6.04883 0L5.90258 0.00454438C2.84213 0.142942 0.316676 2.54487 0.0270735 5.59252C-0.162139 7.62387 0.648832 9.61721 2.19641 10.9244C2.51782 11.1962 2.78429 11.5403 2.96648 11.92C3.15032 12.303 3.24369 12.7095 3.24369 13.1292C3.24369 13.3139 3.28707 13.4878 3.35978 13.6456V15.1829C3.35978 15.6824 3.65806 16.1112 4.08482 16.307V16.7614C4.08523 17.4443 4.64172 18 5.3242 18ZM7.18659 16.7606C7.18659 16.9887 7.00109 17.1737 6.77346 17.1737H6.04883H5.3242C5.09657 17.1737 4.91108 16.9882 4.91108 16.7606V16.4219H6.04883H7.18659V16.7606ZM7.91163 15.1829C7.91163 15.4105 7.72655 15.596 7.4985 15.596H6.04883H4.59916C4.37112 15.596 4.18604 15.4105 4.18604 15.1829V14.3285C4.28188 14.3525 4.38021 14.3686 4.48308 14.3686H6.04883H7.61459C7.71746 14.3686 7.81578 14.3525 7.91163 14.3285V15.1829ZM4.06995 13.1292C4.06995 12.5847 3.94931 12.0572 3.71135 11.5622C3.47876 11.0784 3.13917 10.6397 2.72976 10.2935C1.38833 9.16071 0.6856 7.43218 0.849612 5.67019C1.10038 3.03071 3.28831 0.949782 5.92076 0.830388L6.04883 0.826257L6.15831 0.829975C8.80935 0.949782 10.9973 3.03071 11.2476 5.66936C11.4121 7.43218 10.7093 9.16071 9.3679 10.2935C8.9585 10.6397 8.6189 11.0784 8.38631 11.5622C8.14835 12.0572 8.02772 12.5847 8.02772 13.1292C8.02772 13.3569 7.84264 13.5423 7.61459 13.5423H6.04883H4.48308C4.25503 13.5423 4.06995 13.3569 4.06995 13.1292Z",
    fill: "url(#paint1_linear_4163_830)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4163_830",
    x1: 3.0451,
    y1: 1.84697,
    x2: 5.29012,
    y2: 5.73546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4163_830",
    x1: 3.00175,
    y1: 1.08035,
    x2: 13.1523,
    y2: 12.8963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.8ede587b165810d937ff0f6a88f7a2b7.svg";
export { ForwardRef as ReactComponent };